/***
*
*   HEADER
*   Header section with title used in main application (can render children)
*
*   PROPS
*   title: title of the view
*   children: children to render (optional)
*
**********/

import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, ViewContext, HoverNav, Button } from 'components/lib';
import Style from './header.module.scss';
import apps from '../../constants/apps.json';
import {User} from './user';
import {SyncIndicator} from './SyncIndicator';

export function Header(props){

  const authContext = useContext(AuthContext);
  const viewContext = useContext(ViewContext);
  const orgName = authContext.orgs?.find(x => x.id === authContext.user?.app_connection_id)?.name;
  const [orgList, setOrgList] = useState([])
  const [trialMsg, setTrialMsg] = useState(undefined);
  const [showTrialBanner, setShowTrialBanner] = useState(() => {
    // Check localStorage for dismissal state
    const dismissed = localStorage.getItem('trialBannerDismissed');
    return dismissed !== 'true';
  });
  
  
    // function webSocketMsg(data) {
    //   console.log("header.webSocketMsg: " + data);
    //   viewContext.notification.show(data, 'success', true, 'toast');

    // }
    
    // useEffect(() => {
    //   // Assuming userId is passed as a prop to this component
    //   // console.log(JSON.stringify(authContext))
      
    //   //authContext.createWebSocket(webSocketMsg);
    //   authContext.wsMessageHandler((data) => (data) => webSocketMsg(data));
  
    // }, [authContext.user]); 

    
  useEffect(() => {
    // Only show trial messages if user is actually on trial (has trial_expires date and it's in the future)
    const isOnTrial = authContext?.user?.trial_expires && authContext?.user?.trial_expires > 0;
    const isPaidPlan = authContext?.user?.plan && authContext?.user?.plan !== "free";
    
    if(isOnTrial && !isPaidPlan) {
      setTrialMsg(authContext?.user?.trial_expires + " days left on your trial - ");
    } else if (authContext?.user?.plan === "free" && authContext?.user?.trial_expires <= 0) {
      // Only show "trial expired" if they actually had a trial that expired
      const hadTrial = authContext?.user?.trial_expires !== null && authContext?.user?.trial_expires !== undefined;
      if (hadTrial) {
        setTrialMsg("Trial expired - ");
      }
    } else {
      setTrialMsg(undefined);
      // If not on free plan, clear any dismissal state
      localStorage.removeItem('trialBannerDismissed');
    }
  }, [authContext.user]);

  useEffect(() => {
    var orgListTmp = [];
    authContext.orgs.forEach((org) => {
      if(org.is_notification_conn === false) {
        orgListTmp.push(org);
      }
    })
    orgListTmp.push({
        name: '+ Add Data Connection',
        id: ''
    })
    setOrgList(orgListTmp)
  }, [authContext.orgs]);

  const getAppIcon = (appId) => {
    const app = apps.find(app => app.short_name === appId);
    return app ? app.icon : null;
  };

  const selectedOrg = authContext.orgs?.find(x => x.id === authContext.user?.app_connection_id);
  const selectedOrgIcon = selectedOrg ? getAppIcon(selectedOrg.app) : null;

  return (
    <>
    
    
{trialMsg && showTrialBanner &&
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#ff9500',
      color: 'white',
      padding: '12px 16px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      zIndex: 1000,
      maxWidth: '400px',
      fontSize: '14px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>{trialMsg} <a href="/firm/billing" style={{ color: 'white', textDecoration: 'underline' }}>Upgrade Now</a></span>
        <button 
          onClick={() => {
          setShowTrialBanner(false);
          localStorage.setItem('trialBannerDismissed', 'true');
        }}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            marginLeft: '10px',
            fontSize: '16px'
          }}
        >
          ×
        </button>
      </div>
    </div>
}
    {!authContext.user &&
    <div style={{backgroundColor: 'orange', height: '40px', paddingTop: '10px', margin: '-1.5625em -1.5625em 1.5625em -1.5625em', color: 'white', textAlign: 'center'}}>{authContext.user.plan}</div>
    }
    <header className={ Style.header }>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          { props.title && <h1 style={{marginTop: -5, marginBottom: 0}}>{ props.title }</h1> }

          {authContext.orgs?.length && props.layout !== "firm" ? 
            <HoverNav
                dark
                image={ selectedOrgIcon } 
                label={ orgName } 
                className={ Style.hoverNav }
                align='left' >
                { orgList.map(org => {
                    const appIcon = getAppIcon(org.app);
                    return (
                      <Button 
                        key={ org.id }
                        text={ 
                          <span style={{ display: 'flex', alignItems: 'center' }}>
                            { appIcon && <img src={ appIcon } alt={ org.name } style={{ width: 15, height: 15, marginRight: 5 }} /> }
                            { org.name }
                          </span>
                        }
                        action={() => {
                          viewContext.setLoading(true);
                          if(org.id === '') {
                            window.location = '/client/connections'
                          } else {
                            authContext.switchApp(org.id, '/dashboard');
                          }
                        }}
                      />
                    );
                  }
                )}
              </HoverNav>
              :
              null
          }
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SyncIndicator />
          <User layout={props.layout}/>
        </div>
      </div>
      { props.children }

    </header>
    </>
  );
}
